export default class MessageService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getAdminMessage() {
    return this.$http.get('/api/message/load_nasc_message');
  }

  getCompanyMessage() {
    return this.$http.get('/api/message/load_company_message');
  }

  updateAdminMessage(message) {
    return this.$http.put('/api/message/nasc', {
      message
    });
  }

  updateCompanyMessage(message) {
    return this.$http.put('/api/message/company', {
      message
    });
  }
}



// WEBPACK FOOTER //
// ./services/message.service.js